import { useState, useEffect, useContext } from 'react'
import { NavLink }          from 'react-router-dom'
import { useLocation }      from 'react-router-dom'
import { SceneContext }     from './SceneContext'

import Checkbox             from '@material-ui/core/Checkbox'
import FormControlLabel     from '@material-ui/core/FormControlLabel'
import LockTwoToneIcon      from '@material-ui/icons/LockTwoTone'
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined'
import deepOrange           from '@material-ui/core/colors/deepOrange'

import './css/DevMenu.css'

export default function DevMenu() {

    const [lock, setLock]   = useState(false)
    const location          = useLocation()
    const context           = useContext(SceneContext)
    
    useEffect(() => {
        console.log("Cambio escena!")
        context.changeScene()
    }, [location])

    const generateLinkList = () => {
        let links = []
    
        if (Object.keys(context.scenes_list).length == 0) {
            links.push(<li key={0}>Cargando...</li>)   
        } else {
            const ordered = context.scenes_list
            links = Object.keys(ordered).map((name, index) => {
                return (
                    <li key={index}> 
                        <NavLink activeClassName='is-active' to={name} key={index}> { name } </NavLink> 
                    </li>
                )
            })
        }
    
        return (<ul> {links} </ul>)
    }
    
    const lock_checkbox = () => {
        return (
            <FormControlLabel
                style={{ marginLeft:'8px' }}
                control={   
                    <Checkbox 
                        name="checkedH"
                        size="small"
                        onClick = { () => setLock(e=>!e) }
                        icon = { <LockOpenOutlinedIcon style={{ color: deepOrange[50] }} />}
                        checkedIcon={ <LockTwoToneIcon style={{ color: deepOrange[500] }} />} 
                    /> 
                } 
            />
        )
    }
    
    const compute_style = () => {
        let style = {}
    
        if(lock) {
            style.opacity = '1'
            style.width = '120px'
        }
    
        if(context.dev_mode)
            style.display = "block"
        else
            style.display = "none"
    
        return style
    }
        
    return ( 
        <div id="dev-menu" style={ compute_style() }>
            <h1>Navigation</h1>
            { generateLinkList() }
            { lock_checkbox() }
        </div>
    )
}

